import { useState, useContext, Suspense } from "react";
import { Drawer, Box, useTheme, Toolbar } from "@mui/material";

import { BrandContext } from "../../App";

import { TopNav } from "../complex/TopNav";
import SideMenu from "../complex/SideMenu";

import { AppContainer } from "./styles";

import logo from "../../assets/logos/3x-logo.png";

import BreadCrumbs from "../Breadcrumbs/Breadcrumbs";

import { useUI } from "../../contexts/UIContext";

import MinimalTopNav from "../../components/MinimalTopNav/MinimalTopNav";

const LandingLayout = (props) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();

  const {
    sideMenuOpen,
    setSideMenuOpen,
    isMobile,
    showFooter,
    showCrumbs,
    layoutMode,
  } = useUI();

  const { children, topnavminimal } = props;

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
    setSideMenuOpen(true);
  };

  const toggleDrawer = () => {
    setSideMenuOpen((prev) => !prev);
  };

  let drawerWidth = 300;
  if (!sideMenuOpen) drawerWidth = 70;

  return (
    <AppContainer id="app-container" showFooter={showFooter}>
      {layoutMode === "minimal" && (
        <div id="minimal-nav-container">
          <MinimalTopNav />
        </div>
      )}
      {/* Hamburger button only on mobile */}
      {isMobile && layoutMode !== "minimal" && (
        <Box id="mobile-toolbar" component="header">
          <a href="/">
            <img src={logo} alt="GuruNow" />
          </a>
          <button onClick={handleDrawerToggle}>
            <svg
              width="20"
              height="14"
              viewBox="0 0 20 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 7H13M1 1H19M1 13H19"
                stroke="#FEFEFE"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </Box>
      )}

      {/* Drawer */}
      {layoutMode === "full" && (
        <Drawer
          anchor={isMobile ? "right" : "left"}
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? mobileOpen : true}
          onClose={() => setMobileOpen(false)}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              backgroundColor: "rgb(2, 0, 43)",
              boxSizing: "border-box",
              borderRight: "1px solid",
              borderImage: `linear-gradient(to bottom, ${theme.palette.border.brand}, ${theme.palette.background.button_primary}) 1`,
            },
          }}
        >
          <SideMenu
            open={sideMenuOpen}
            toggleDrawer={toggleDrawer}
            isMobile={isMobile}
            toggleMobileMenu={setMobileOpen}
          />
        </Drawer>
      )}
      {/* Page content */}
      <Box
        id="core-app-content"
        component="main"
        sx={{
          flexGrow: 1,
          transition: "margin 0.3s",
          marginLeft:
            isMobile || layoutMode === "minimal" ? 0 : `${drawerWidth}px`,
        }}
      >
        {showCrumbs && !isMobile && (
          <Suspense>{layoutMode === "full" && <BreadCrumbs />}</Suspense>
        )}
        {children}
      </Box>
    </AppContainer>
  );
};

export default LandingLayout;
